export default __webpack_public_path__ + "static/media/Nunito-Bold.a282f39d.ttf";